import { FunctionComponent, PropsWithChildren } from "react";
import {
  Accordion as ArkAccordion,
  useAccordionItemContext,
  UseAccordionItemContext,
} from "@ark-ui/react";

import "./accordion.css";

export const Accordion: FunctionComponent<PropsWithChildren<ArkAccordion.RootProps>> = ({
  children,
  ...props
}) => {
  return <ArkAccordion.Root {...props}>{children}</ArkAccordion.Root>;
};

type AccordionItemProps = PropsWithChildren<{
  trigger: React.ReactNode | ((context: UseAccordionItemContext) => React.ReactNode);
}>;

export const AccordionItem: FunctionComponent<
  AccordionItemProps & ArkAccordion.ItemBaseProps
> = ({ trigger, value, children, ...props }) => {
  return (
    <ArkAccordion.Item value={value} {...props}>
      <AccordionItemInner trigger={trigger}>{children}</AccordionItemInner>
    </ArkAccordion.Item>
  );
};

const AccordionItemInner: FunctionComponent<AccordionItemProps> = ({
  trigger,
  children,
}) => {
  const context = useAccordionItemContext();

  return (
    <>
      <ArkAccordion.ItemTrigger>
        {typeof trigger === "function" ? trigger(context) : trigger}
      </ArkAccordion.ItemTrigger>
      <ArkAccordion.ItemContent>{children}</ArkAccordion.ItemContent>
    </>
  );
};
